"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDetailsAttributeValues = void 0;
const react_1 = __importStar(require("react"));
const use_product_details_values_1 = require("./client/use-product-details-values");
const product_details_attribute_styles_1 = require("./product-details-attribute.styles");
const client_constants_1 = require("../../../../client/client.constants");
const attributes_1 = require("../../../../constants/attributes");
const autocomplete_tags_1 = require("../../../../generic/autocomplete-tags");
const ai_sparkle_icon_component_1 = __importDefault(require("../../../../../icons/svg/ai-sparkle-icon.component"));
const localization_1 = require("../../../../../localization");
const store_1 = require("../../../../../store");
const ProductDetailsAttributeValues = ({ attributeName, initialSelectedValues, productTreeNodeId, disabled, onSave, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const initialSelectedValuesList = (0, react_1.useMemo)(() => initialSelectedValues.map(({ value }) => value), [initialSelectedValues]);
    const [selectedValues, setSelectedValues] = (0, react_1.useState)(initialSelectedValuesList);
    const [currentValues, setCurrentValues] = (0, react_1.useState)(initialSelectedValuesList);
    const { loadProductDetailsValues, isLoading, data, error, pagination: { onNextPage, isLoadingMore, hasNextPage, }, onSearch, } = (0, use_product_details_values_1.useProductsDetailsValues)({
        catalogId: selectedCatalogId,
        productTreeNodeId,
        attributeName,
        pageSize: client_constants_1.PAGE_SIZE_LARGE,
        options: { fetchPolicy: 'cache-first' },
    });
    const handleDropdownOpen = () => void loadProductDetailsValues();
    const options = (0, react_1.useMemo)(() => {
        const NOT_APPLICABLE = attributes_1.SpecialAttributeValue.NotApplicable;
        const baseValues = isLoading || !(data === null || data === void 0 ? void 0 : data.length)
            ? initialSelectedValuesList
            : [...data, NOT_APPLICABLE];
        const isSelected = (value) => currentValues.includes(value);
        const isNotApplicable = (value) => value === NOT_APPLICABLE;
        const getPriority = (value) => {
            if (isSelected(value))
                return 0;
            if (isNotApplicable(value))
                return 1;
            return 2;
        };
        return [...baseValues]
            .sort((a, b) => {
            const priorityDiff = getPriority(a) - getPriority(b);
            return priorityDiff !== 0 ? priorityDiff : a.localeCompare(b);
        })
            .map((value) => ({
            label: value,
            value,
            pinned: isNotApplicable(value),
        }));
    }, [isLoading, data, initialSelectedValuesList, currentValues]);
    const handleDeleteValue = (valueToDelete) => {
        if (valueToDelete === attributes_1.SpecialAttributeValue.Unknown) {
            return;
        }
        const newValues = currentValues.filter((value) => value !== valueToDelete);
        if (!newValues.length) {
            newValues.push(attributes_1.SpecialAttributeValue.Unknown);
        }
        onSave(newValues, selectedValues);
        setSelectedValues(newValues);
    };
    const handleSave = () => {
        onSave(currentValues, selectedValues);
        setSelectedValues(currentValues);
    };
    const handleCancel = () => setCurrentValues(selectedValues);
    const handleChange = (values) => {
        let newValues = [...values];
        if (newValues.includes(attributes_1.SpecialAttributeValue.NotApplicable)) {
            if (!currentValues.includes(attributes_1.SpecialAttributeValue.NotApplicable)) {
                // remove other values when "set to N/A"
                newValues = [attributes_1.SpecialAttributeValue.NotApplicable];
            }
            else {
                // remove N/A when another value is added
                newValues = newValues.filter((value) => value !== attributes_1.SpecialAttributeValue.NotApplicable);
            }
        }
        if (newValues.includes(attributes_1.SpecialAttributeValue.Unknown) && newValues.length > 1) {
            setCurrentValues(newValues.filter((value) => value !== attributes_1.SpecialAttributeValue.Unknown));
        }
        else if (!newValues.length) {
            setCurrentValues([attributes_1.SpecialAttributeValue.Unknown]);
        }
        else {
            setCurrentValues(newValues);
        }
    };
    const getChipProps = (0, react_1.useCallback)((value) => {
        var _a;
        const { valid } = (_a = initialSelectedValues.find((item) => item.value === value)) !== null && _a !== void 0 ? _a : {};
        const isInStrategyValue = data.includes(value) || value === attributes_1.SpecialAttributeValue.NotApplicable;
        return {
            accent: valid || isInStrategyValue,
            icon: (valid || isInStrategyValue) ? react_1.default.createElement(ai_sparkle_icon_component_1.default, null) : null,
        };
    }, [data, initialSelectedValues]);
    const renderOptionLabel = (0, react_1.useCallback)((option) => {
        const { valid } = initialSelectedValues.find((item) => item.value === option.value) || {};
        let formattedLabel = option.label;
        if (option.value === attributes_1.SpecialAttributeValue.NotApplicable) {
            formattedLabel = t({ key: 'NOT_APPLICABLE' });
        }
        return (react_1.default.createElement(product_details_attribute_styles_1.StyledOptionWrapper, null, formattedLabel, (valid || data.includes(option.value) || option.value === attributes_1.SpecialAttributeValue.NotApplicable) && react_1.default.createElement(ai_sparkle_icon_component_1.default, null)));
    }, [initialSelectedValues, data, currentValues, t]);
    const renderTagLabel = (0, react_1.useCallback)((value) => (value === attributes_1.SpecialAttributeValue.NotApplicable
        ? t({ key: 'NOT_APPLICABLE' }) : value), [t]);
    const DIVIDER_OPTION = {
        label: '__DIVIDER__',
        value: '__DIVIDER__',
        isDivider: true,
    };
    const groupedOptions = (0, react_1.useMemo)(() => {
        const pinned = options.filter((opt) => opt.pinned);
        const regular = options.filter((opt) => !opt.pinned);
        if (!pinned.length)
            return regular;
        return [...pinned, DIVIDER_OPTION, ...regular];
    }, [options]);
    return (react_1.default.createElement(autocomplete_tags_1.AutocompleteTags, { placeholder: "", selected: currentValues, options: groupedOptions, moreItemsLoading: isLoadingMore, isDisabled: disabled, disableClearable: true, getChipProps: getChipProps, onChange: handleChange, onDelete: handleDeleteValue, onSave: handleSave, onCancel: handleCancel, renderOptionLabel: renderOptionLabel, onClose: handleCancel, renderTagLabel: renderTagLabel, onOpen: handleDropdownOpen, onLoadMore: onNextPage, onSearch: onSearch, hasNextPage: hasNextPage, isLoading: isLoading, errorMessage: error === null || error === void 0 ? void 0 : error.message, getOptionDisabled: (option) => (option).isDivider === true }));
};
exports.ProductDetailsAttributeValues = ProductDetailsAttributeValues;
